var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        { show: _vm.getIsShowEditReportRef && !_vm.isShowAddReference },
        { notAllowClick: _vm.isLoadingSaveBriefingResource },
      ],
      style: { display: _vm.isShowAddReference ? "none" : "block" },
      attrs: {
        id: "go-add-reference",
        "data-backdrop": "static",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-resource-edit" }, [
        _c("div", { staticClass: "modal-content-primary" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("briefing.my-report.edit-reference.titel"))
                ),
                _c("small", { staticClass: "go-count" }, [
                  _vm._v(_vm._s(_vm.referentItems.length)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: {
                    id: "closeModalButton",
                    type: "button",
                    "data-dismiss": "modal",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "go-tooltip-area",
                      attrs: { "data-toggle": "tooltip", title: "Close" },
                      on: { click: _vm.handleCloseModel },
                    },
                    [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "go-list-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass:
                            "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                          attrs: { settings: _vm.scrollSettings },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                overflow: "hidden",
                                width: "auto",
                                height: "auto",
                              },
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "go-card-sub-list go-card-resource",
                                },
                                [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "go-list-item",
                                      staticStyle: { margin: "4px" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "go-card-add",
                                          attrs: {
                                            disabled:
                                              ((!_vm.getSelectedResource ||
                                                !_vm.getSelectedResource
                                                  .owner_user_key ||
                                                false ||
                                                !_vm.userKey ||
                                                _vm.userKey === "" ||
                                                _vm.userKey !==
                                                  _vm.getSelectedResource
                                                    .owner_user_key) &&
                                                !_vm.getIsOpenPopupEditReferenceForPage) ||
                                              _vm.isLoadingSaveBriefingResource,
                                            id: "go-btn-addReference",
                                          },
                                          on: {
                                            click:
                                              _vm.handleOpenPopupAddReferenceModal,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "go-card-body" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "go-icon-40 go-icon-plus",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "go-info-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "briefing.my-report.edit-reference.add"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.referentItems,
                                    function (document, index) {
                                      return _c("reference-card-component", {
                                        key:
                                          "reference_card_edit_" +
                                          index +
                                          "_" +
                                          Math.floor(Math.random() * 10000),
                                        attrs: {
                                          "form-model": document,
                                          "style-for":
                                            _vm.REFERENCE_STYLE_FOR
                                              .EDIT_REFERENCE,
                                          "index-item": index,
                                          "is-loading-save-briefing-resource":
                                            _vm.isLoadingSaveBriefingResource,
                                        },
                                        on: {
                                          handleDeleteReference:
                                            _vm.handleDeleteReference,
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "go-loading-wrapper" },
                    [_c("go-loading")],
                    1
                  ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-default",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    disabled: _vm.isLoadingSaveBriefingResource,
                  },
                  on: { click: _vm.handleCloseModel },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("briefing.my-report.edit-reference.cancel")
                      ) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-btn-area" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: {
                      type: "button",
                      disabled: _vm.isLoadingSaveBriefingResource,
                    },
                    on: { click: _vm.handleResetOriginReferenceDocuments },
                  },
                  [
                    _c("i", { staticClass: "go-icon-16 go-icon-refresh" }),
                    _c("em", { staticClass: "go-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("briefing.my-report.edit-reference.undoEdit")
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: {
                      disabled:
                        !_vm.referentItems ||
                        (_vm.referentItems && _vm.referentItems.length < 1) ||
                        !_vm.checkIfCanSaveReferenceDocuments() ||
                        _vm.isLoadingSaveBriefingResource,
                      type: "button",
                    },
                    on: { click: _vm.saveReferenceDocuments },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "briefing.my-report.edit-reference.edit-complete"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }